// extracted by mini-css-extract-plugin
export var container = "dy_g";
export var fadeDiv = "dy_gt";
export var placeholderWrapper = "dy_q7";
export var video = "dy_q8";
export var videoWrapper = "dy_hJ";
export var vimeoPlayer = "dy_q9";
export var wrapper = "dy_B";